


document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.abz-multicolumn-slider');
  if (swiperEl) {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 10
        }
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.swiper.abz-featured-swiper');
  sliders.forEach(function (slider) {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        750: { slidesPerView: 2 },
        990: { slidesPerView: 2 },
        1200: { slidesPerView: 4 }
      }
    });
  });
});




document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.announcement-bar-slider', {
    loop: true,
    autoplay: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.abz-swiper-marquee');
  sliders.forEach(function (slider) {
    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev')
      },
      breakpoints: {
        750: { slidesPerView: 2 },
        990: { slidesPerView: 2 },
        1200: { slidesPerView: 4 }
      }
    });
  });
});



// Header search bar start
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-action="unfix-search"]').forEach(button => {
    button.addEventListener("click", function () {
      document.documentElement.classList.remove("search-is-fixed");
      document.querySelector('.header__search-bar-wrapper').classList.remove("is-visible");
    });
  });
});

// Header search bar end



class SideDrawer {
  constructor(element) {
    this.element = element;
    if (!this.element) return;

    this.isOpen = false;
    this.drawer = this.element.querySelector('.side-drawer');
    this.overlay = this.element.querySelector('.side-drawer-overlay');
    this.closeButton = this.element.querySelector('[data-action="close-drawer"]');

    this.bindEvents();
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  }

  open() {
    this.isOpen = true;
    this.element.setAttribute('open', '');
    document.body.classList.add('no-scroll');
    // Accessibility.trapFocus(this.drawer, 'side-drawer');
  }

  close() {
    this.isOpen = false;
    this.element.removeAttribute('open');
    document.body.classList.remove('no-scroll');
    // Accessibility.releaseFocus();
  }


  async refresh() {
    try {
      const response = await fetch('?section_id=side-drawer-cart');
      if (!response.ok) throw new Error('Network response was not ok');
      const html = await response.text();
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      const newDrawerContent = tempDiv.querySelector('.side-drawer');
      const newHeaderCount = tempDiv.querySelector('#cart-count-bubble');

      if (newDrawerContent) {
        this.drawer.innerHTML = newDrawerContent.innerHTML;
        this.closeButton = this.element.querySelector('[data-action="close-drawer"]');
        this.closeButton.addEventListener('click', this.close.bind(this));
      }

      const headerCartCount = document.querySelector('#cart-count-bubble');
      if (headerCartCount && newHeaderCount) {
        headerCartCount.innerHTML = newHeaderCount.innerHTML;
        headerCartCount.classList.toggle('is-visible', newHeaderCount.classList.contains('is-visible'));
      }
    } catch (error) {
      console.error('Failed to refresh side drawer content:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.theme.cartType !== 'side-drawer') return;

  const drawerElement = document.querySelector('.shopify-section--side-drawer-cart');
  if (!drawerElement) return;

  const sideDrawer = new SideDrawer(drawerElement);

  const cartButton = document.querySelector('a[href="/cart"]');
  if (cartButton) {
    cartButton.addEventListener('click', (e) => {
      e.preventDefault();
      sideDrawer.open();
    });
  }

  document.body.addEventListener('product:added', () => {
    sideDrawer.refresh().then(() => {
      sideDrawer.open();
    });
  });

  document.body.addEventListener('cart:refresh', () => {
    sideDrawer.refresh();
  });
});